// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.freeze-overlay[data-v-ecb275a8] {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: grid;
  place-items: center;
  padding: 16px;
  background: #D9D9D999;
  overscroll-behavior: contain;
}
.freeze-content[data-v-ecb275a8] {
  box-sizing: border-box;
  width: min(425px, 100%);
  padding: 30px 16px 40px;
  border-radius: 8px;
  background: #fff;
  text-align: center;
}
.freeze-content[data-v-ecb275a8]:focus {
  outline: none;
}
.freeze-title[data-v-ecb275a8] {
  margin: 10px 0 16px;
  color: #f71515;
  font-size: 20px;
  font-weight: 600;
}
.freeze-message[data-v-ecb275a8] {
  margin: 0;
  color: #555;
  font-size: 14px;
  line-height: 1.7;
  white-space: pre-line;
}
`, "",{"version":3,"sources":["webpack://./src/vue/DashboardFreezeModal.vue"],"names":[],"mappings":";AA6BA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,4BAA4B;AAC9B;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AAEA;EACE,aAAa;AACf;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB","sourcesContent":["<script setup lang=\"ts\">\n  import { onMounted, ref } from 'vue';\n  import AlertIcon from '../view/assets/icons/AlertIcon.vue';\n\n  const freezeModal = ref<HTMLDivElement | null>(null);\n\n  onMounted(() => {\n    freezeModal.value?.focus();\n  });\n</script>\n\n<template>\n  <div class=\"freeze-overlay\">\n    <div\n      ref=\"freezeModal\"\n      class=\"freeze-content\"\n      role=\"dialog\"\n      aria-modal=\"true\"\n      aria-labelledby=\"dashboard-freeze-title\"\n      tabindex=\"-1\"\n    >\n      <AlertIcon/>\n      <div id=\"dashboard-freeze-title\" class=\"freeze-title\">アカウントを一時停止しています</div>\n      <div id=\"dashboard-freeze-message\" class=\"freeze-message\">ご利用料金のお支払いが確認できないため、現在アカウントを一時停止しています。お支払い状況をご確認のうえ、未払い分のお支払いをお願いいたします。すでにお手続きいただいている場合は、行き違いの可能性もございますので、何卒ご容赦くださいませ。詳細はサポートチャットもしくはお電話にてお問い合わせください。</div>\n    </div>\n  </div>\n</template>\n\n<style scoped>\n.freeze-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: grid;\n  place-items: center;\n  padding: 16px;\n  background: #D9D9D999;\n  overscroll-behavior: contain;\n}\n\n.freeze-content {\n  box-sizing: border-box;\n  width: min(425px, 100%);\n  padding: 30px 16px 40px;\n  border-radius: 8px;\n  background: #fff;\n  text-align: center;\n}\n\n.freeze-content:focus {\n  outline: none;\n}\n\n.freeze-title {\n  margin: 10px 0 16px;\n  color: #f71515;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.freeze-message {\n  margin: 0;\n  color: #555;\n  font-size: 14px;\n  line-height: 1.7;\n  white-space: pre-line;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
